<div class="show-form-container">
  <div class="header-and-form-container">
    <div class="header-container"
         mat-dialog-title>
      <div class="header-title">
        {{ isUpdate ? "Editar evento" : "Novo evento" }}
      </div>
      <div class="header-close"
           mat-dialog-close>
        <span class="material-icons icon-close"> close </span>
      </div>
    </div>
    <mat-dialog-content>
      <div class="form-container">
        <mat-horizontal-stepper [linear]="true"
                                #stepper>
          <mat-step [stepControl]="firstFormGroup"
                    state="settings">
            <ng-template matStepLabel>Informações Gerais</ng-template>
            <app-show-first-step [firstFormGroup]="firstFormGroup"
                                 (deleteFiles)="deleteFiles($event)"></app-show-first-step>
            <div class="mat-justify-end">
              <button mat-button
                      matStepperNext>Próximo</button>
            </div>
          </mat-step>
          <mat-step [stepControl]="secondFormGroup"
                    state="school">
            <ng-template matStepLabel>Segmentação</ng-template>
            <app-show-second-step [secondFormGroup]="secondFormGroup"
                                  [show]="show"></app-show-second-step>
            <div class="mat-justify-between">
              <button mat-button
                      matStepperPrevious>Anterior</button>
              <button mat-button
                      matStepperNext>Próximo</button>
            </div>
          </mat-step>
          <mat-step [stepControl]="thirdFormGroup"
                    state="chair">
            <ng-template matStepLabel>Mapa de Assentos</ng-template>
            <app-show-third-step [thirdFormGroup]="thirdFormGroup"></app-show-third-step>
            <div>
              <button mat-button
                      matStepperPrevious>Anterior</button>
            </div>
          </mat-step>
          <ng-template matStepperIcon="school">
            <mat-icon>school</mat-icon>
          </ng-template>
          <ng-template matStepperIcon="settings">
            <mat-icon>settings</mat-icon>
          </ng-template>

          <ng-template matStepperIcon="chair">
            <mat-icon>chair</mat-icon>
          </ng-template>
        </mat-horizontal-stepper>
      </div>
    </mat-dialog-content>
  </div>
  <mat-dialog-actions align="center">
    <div class="footer-container">
      <button mat-raised-button
              class="btn-cancel"
              mat-dialog-close>
        Cancelar
      </button>
      <div class="divider"></div>
      <button mat-raised-button
              [className]="(firstFormGroup.invalid || secondFormGroup.invalid || thirdFormGroup.invalid) || disabled
            ?  'mat-focus-indicator btn-save disabled mat-raised-button mat-button-base submit-disabled'
            :'mat-focus-indicator btn-save mat-raised-button mat-button-base'"
              [disabled]="(firstFormGroup.invalid || secondFormGroup.invalid || thirdFormGroup.invalid) || disabled"
              (click)="saveShow()">
        {{ !isUpdate ? "Criar" : "Salvar" }}
      </button>
    </div>
  </mat-dialog-actions>
</div>
